/**
 *  @swagger
 *  definitions:
 *    ChampionshipRegattaParams:
 *      type: object
 *      properties:
 *        ChampionshipId:
 *          description: ID of the associated Championship
 *          type: string
 *        RegattaId:
 *          description: ID of the associated Regatta
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    ChampionshipRegattaCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipRegattaParams'
 *        - type: object
 *          required:
 *            - ChampionshipId
 *            - RegattaId
 *
 *  @swagger
 *  definitions:
 *    ChampionshipRegattaQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the ChampionshipRegatta
 *              type: string
 *        - $ref: '#/definitions/ChampionshipRegattaParams'
 *
 *  @swagger
 *  definitions:
 *    ChampionshipRegattaUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipRegattaQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    ChampionshipRegatta:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipRegattaCreateParams'
 *        - $ref: '#/definitions/ChampionshipRegattaUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      ChampionshipRegatta:
 *        allOf:
 *          - $ref: '#/definitions/ChampionshipRegatta'
 *          - type: object
 *            properties:
 *              Championship:
 *                description: Championship of the ChampionshipRegatta
 *                $ref: '#/components/schemas/Championship'
 *              Regatta:
 *                description: Regatta of the ChampionshipRegatta
 *                $ref: '#/components/schemas/Regatta'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  ChampionshipId: string;
  RegattaId: string;
};

export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Championship?: $Model<'Championship'>;
  Regatta?: $Model<'Regatta'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'ChampionshipRegatta'> => {
  const ChampionshipRegatta = stack.define(
    'ChampionshipRegatta',
    fields(Sequelize),
    {
      tableName: 'ChampionshipRegattas',
    },
  );

  ChampionshipRegatta.associate = (models: $ModelClasses) => {
    models.ChampionshipRegatta.belongsTo(
      models.Championship,
      {
        as: 'Championship',
        foreignKey: 'ChampionshipId',
      },
    );
    models.ChampionshipRegatta.belongsTo(
      models.Regatta,
      {
        as: 'Regatta',
        foreignKey: 'RegattaId',
      },
    );
  };

  return ChampionshipRegatta;
});
